<template>
	<table class="grid admin">
		<thead>
			<tr>
				<th :style="columnStyle">
					<div class="bar bg-blue rider">
						<h3>Rider</h3> 
					</div>
				</th>
				<th v-for="lot in board.totalLots" :key="lot" :style="columnStyle">
					<div class="bar bg-brown lot">
						<h3>Lot {{ lot }}</h3>
					</div>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="row in (visibleRows)" :key="row" :style="rowStyle(row)">
				<template v-if="showRow(row)">
					<td>
						<Draggable :v-model="[]" group="people" :data-row="row" @end="onPersonDrop" class="draggable" :disabled="board.published">
							<Person :person="peopleById[board.rows[row].person]" v-if="board.rows[row] && board.rows[row].person" :data-id="board.rows[row].person"/>
						</Draggable>
					</td>
					<td v-for="lot in board.totalLots" :key="lot">
						<Draggable :v-model="[]" group="horses" :data-row="row" :data-lot="lot" @end="onHorseDrop" class="draggable" :disabled="board.published">
							<Horse :horse="horsesById[board.rows[row].lots[lot]]" v-on:assignTasks="assignTasks" v-if="board.rows[row] && board.rows[row].lots[lot]" :data-id="board.rows[row].lots[lot]" :tasks="board.tasks[board.rows[row].lots[lot]] || []"/>
						</Draggable>
					</td>
				</template>
			</tr>
		</tbody>
	</table>
</template>

<script>
import { mapState } from 'vuex'
import Draggable from 'vuedraggable'
import Horse from '../../Common/Horse.vue'
import Person from '../../Common/Person.vue'

export default {
	props: ['board', 'split', 'splitPosition'],
	components: {
		Draggable,
		Horse,
		Person
	},
	computed : {
		...mapState({
			people: state => state.people.list,
			horses: state => state.horses.list,
			lots: state => state.lots.list
		}),
		peopleById() {
			return this.mapArrayById(this.$store.getters['people/list'], 'id')
		},
		horsesById() {
			return this.mapArrayById(this.$store.getters['horses/list'], 'id')
		},
		columnStyle() {
			const columnWidth = 100 / (this.board.totalLots + 1)

			return {
				width: columnWidth + '%'
			}
		},
		visibleRows() {
			return this.board.totalRows + 10
		}
	},
	methods: {
		onPersonDrop(move) {
			if(move.from.dataset.row !== move.to.dataset.row) {
				const sourcePerson =  move.item.dataset.id
				const currentTargetRow = this.board.rows[move.to.dataset.row]
				let currentTargetPerson = undefined

				if(currentTargetRow && currentTargetRow.person) {
					currentTargetPerson = currentTargetRow.person
				}

				//request changes
				let changes = []

				if(move.to.dataset.row) {
					//Dropped on board
					changes.push({
						type: 'ASSIGN_PERSON',
						entity: sourcePerson,
						target: { row: move.to.dataset.row }
					})
				} else {
					//Dropped in unallocated
					changes.push({
						type: 'UNASSIGN_PERSON',
						entity: sourcePerson,
					})
				}

				if(currentTargetPerson) {
					if(!move.from.dataset.row) {
						//Person from unallocated tab
						changes.push({
							type: 'UNASSIGN_PERSON',
							entity: currentTargetPerson
						})
					} else {
						//swap positions
						changes.push({
							type: 'ASSIGN_PERSON',
							entity: currentTargetPerson,
							target: { row: move.from.dataset.row }
						})
					}
				} else if(move.from.dataset.row) {
					//Clear where horse came from
					changes.push({
						type: 'CLEAR_PERSON',
						target: { row: move.from.dataset.row }
					})
				}

				this.$emit('change', changes)
			}
		},
		onHorseDrop(move) {
			if(move.from.dataset.row !== move.to.dataset.row || move.from.dataset.lot !== move.to.dataset.lot) {
				const sourceHorse = move.item.dataset.id
				const currentTargetRow = this.board.rows[move.to.dataset.row]
				let currentTargetHorse = undefined

				if(currentTargetRow && currentTargetRow.lots[move.to.dataset.lot]) {
					currentTargetHorse = currentTargetRow.lots[move.to.dataset.lot]
				}

				//request changes
				let changes = []

				if(move.to.dataset.row) {
					changes.push({
						type: 'ASSIGN_HORSE',
						entity: sourceHorse,
						target: { row: move.to.dataset.row, lot: move.to.dataset.lot }
					})
				} else {
					changes.push({
						type: 'UNASSIGN_HORSE',
						entity: sourceHorse,
					})
				}

				if(currentTargetHorse) {
					if(!move.from.dataset.row) {
						//Horse from unallocated tab
						changes.push({
							type: 'UNASSIGN_HORSE',
							entity: currentTargetHorse
						})
					} else {
						//swap positions
						changes.push({
							type: 'ASSIGN_HORSE',
							entity: currentTargetHorse,
							target: { row: move.from.dataset.row, lot: move.from.dataset.lot }
						})
					}
				} else if(move.from.dataset.row) {
					//Clear where horse came from
					changes.push({
						type: 'CLEAR_HORSE',
						target: { row: move.from.dataset.row, lot: move.from.dataset.lot }
					})
				}

				this.$emit('change', changes)
			}
		},
		assignTasks(args) {
			this.$emit('assignTasks', args)
		},
		showRow(row) {
			if(this.split) {
				const n = this.splitPosition - 1

				return Math.abs(row % 2) !== n
			} else {
				return true
			}
		},
		rowStyle(row) {
			if(!this.showRow(row)) {
				return {
					display: 'none'
				}
			} else {
				return {}
			}
		}
	}
}
</script>

<style lang="scss">
.grid.admin {
	border-spacing: 0 5px;
	.bar.horse, .bar.person {
		cursor: pointer;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Board/Grids/Admin.vue